import { render, staticRenderFns } from "./BlankLayout.vue?vue&type=template&id=33044254&"
import script from "./BlankLayout.vue?vue&type=script&lang=ts&"
export * from "./BlankLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zfh/dev/targus-micor/targus-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33044254')) {
      api.createRecord('33044254', component.options)
    } else {
      api.reload('33044254', component.options)
    }
    module.hot.accept("./BlankLayout.vue?vue&type=template&id=33044254&", function () {
      api.rerender('33044254', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BlankLayout.vue"
export default component.exports